import React from 'react';
import { Box, Typography } from 'components/ui';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { WhiteCard } from 'components/styles_components/card';
import ProfileQuery from 'queries/user/profile';
import ShowItemRow from 'components/item/show_item_row';
import Loader from 'components/loader';
import Boolean from 'components/boolean';
import PasswordChangeButton from 'components/user/profile/button/password_change';
import Disable2FaButton from 'components/user/profile/button/disable_two_factor';
import Enable2FaButton from 'components/user/profile/button/enable_two_factor';
import { DividerContainer } from 'components/styles_components/container';

const Show = () => {
  const setError = useError();
  const {
    data = { user: {} },
    loading,
    refetch,
  } = useQuery(ProfileQuery, {
    onError: () => {
      setError('error.user.profile.show');
    },
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <WhiteCard>
        <Typography variant="h5">
          <FormattedMessage id="user.security.two_factor" />
        </Typography>
        <Typography variant="body2" gutterBottom>
          <FormattedMessage id="user.security.two_factor.description" />
        </Typography>
        <DividerContainer />
        <ShowItemRow label={<FormattedMessage id="user.2fa" />}>
          <Boolean value={data.user.otpEnabled} />
        </ShowItemRow>
        <Box display="flex" justifyContent="flex-end">
          {data.user.otpEnabled ? (
            <Disable2FaButton refetch={refetch} />
          ) : (
            <Enable2FaButton refetch={refetch} />
          )}
        </Box>
      </WhiteCard>

      <WhiteCard>
        <Typography variant="h5">
          <FormattedMessage id="user.security.change_password" />
        </Typography>
        <Typography variant="body2" gutterBottom>
          <FormattedMessage id="user.security.change_password.description" />
        </Typography>
        <DividerContainer />

        {[1, 2, 3, 4].map((number) => (
          <ShowItemRow
            key={number}
            label={<FormattedMessage id={`user.security.password.recommendation.${number}`} />}
          >
            <FormattedMessage id={`user.security.password.recommendation.${number}.description`} />
          </ShowItemRow>
        ))}
        <Box display="flex" justifyContent="flex-end">
          <PasswordChangeButton user={data.user} refetch={refetch} />
        </Box>
      </WhiteCard>
    </>
  );
};

export default Show;
